import AppContext from "PFApp/app_context";
import { usePage } from "PFApp/use_page";
import { fetchPaginatedCollection, fetchPaginatedDocs } from "PFCore/helpers/collection";
import { ApiRoute } from "PFCore/utilities/routes";
import { useContext, useEffect } from "react";

export const useAuditLogsPage = (initPage) => {
  const {
    store: {
      currentAccount: { id: account_id }
    }
  } = useContext(AppContext);
  const { page, setPage, mergePage, resetPage } = usePage(`audit_logs`, initPage);

  const fetchLogs = (page = 1, date) => {
    const params = {
      account_id,
      page: page,
      perPage: 500,
      time_from:
        moment(date?.from).toISOString() || moment().subtract(3, "days").startOf("day").toISOString(),
      time_until: moment(date?.until).toISOString() || moment().endOf("day").toISOString()
    };

    fetchPaginatedCollection(ApiRoute("/api/audit_logs"), params)
      .then((response) =>
        mergePage({
          loaded: true,
          auditLogs: response
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          errors: ["there was an error"]
        })
      );
  };

  const generateDocument = (page, date) =>
    fetchPaginatedDocs("csv", ApiRoute(`/api/audit_logs`), {
      account_id,
      page: page,
      perPage: 500,
      time_from: moment(date?.from).toISOString(),
      time_until: moment(date?.until).toISOString()
    });

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    fetchLogs();
  }, []);

  return { ...page, fetchLogs, generateDocument };
};
